$(document).ready(function(){

  // $(document).on('click', '.s-announcementbar a[href^="#"]', function (event) {
  //   event.preventDefault();
  //   $('html, body').animate({
  //       scrollTop: $($.attr(this, 'href')).offset().top
  //   }, 2000);
  // });
  
    if($(window).width() < 576){
    activeSearch()
  }
    $('.temp___faq .footer-link li').click(function () {
       var current_url = $(this).find('a').attr('href');
      var current = current_url.split('#');
      var location_url = current[current.length -1];
      $(".accordion li #" + location_url).click();
    });
  
 if ($(window).width() < 767) {
   $('.menu-footer li').click(function () {
       var current_url = $(this).find('a').attr('href');
      var current = current_url.split('#');
      var location_url = current[current.length -1];
      $(".accordion li #" + location_url).click();
    });
 }

if($(".accordion li").length > 0){
  accordion_active();
}
  
   function accordion_active () {
      var current_url = $(location).attr('href');
      var current = current_url.split('#');
      var location_url = current[current.length -1];
      $(".accordion li #" + location_url).click();
   }

  $('.form_success_inner a').click(function () {
      window.location.href = '/pages/contact'
  })

  if ($(window).width() < 767) {
        $('.menu-footer li').click(function () {
          $('.close-btn').trigger('click');
        });
  }

  $('.cus_input_border').css({'color':"red"});

  
});
$(window).resize(function() {
  if ($(window).width() < 576) {
    activeSearch()  
  }
});
function activeSearch(){
  $('.desk-search_wrap').addClass('active')
}